import React from 'react';
import { FormattedMessage } from 'react-intl';

const cleaningPolicy = {
  cleaning_measures: {
    heading:
      <FormattedMessage
        id="shared_components.cleaning_types.cleaning_measures_heading"
        defaultMessage="What additional measures are you taking to keep your space clean?"
      />,
    items: [
      { key: 'cdc_guidelines',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.cdc_guidelines"
            defaultMessage="The space is cleaned and disinfected in accordance with guidelines from local health authorities"
          />
        )
      },
      { key: 'disinfecting_surfaces',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.disinfecting_surfaces"
            defaultMessage="High touch surfaces and shared amenities have been disinfected"
          />
        )
      },
      { key: 'cleaning_soft_materials',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.cleaning_soft_materials"
            defaultMessage="Soft, porous materials have been properly cleaned or removed"
          />
        )
      },
      { key: 'licensed_cleaner',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.licensed_cleaner"
            defaultMessage="A licensed professional cleaner is hired between bookings"
          />
        )
      },
      { key: 'spacing_bookings',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.spacing_bookings"
            defaultMessage="Bookings are spaced apart to allow for enhanced cleaning"
          />
        )
      }
    ]
  },
  protective_gear: {
    heading: (
      <FormattedMessage
        id="shared_components.cleaning_types.protective_gear_header"
        defaultMessage="What additional protective gear do you provide to your guests?"
      />
    ),
    listingHeader: (
      <FormattedMessage
        id="shared_components.cleaning_types.protective_gear_listing_header"
        defaultMessage="Protective gear"
      />
    ),
    listingSubheader: (
      <FormattedMessage
        id="shared_components.cleaning_types.protective_gear_listing_subheader"
        defaultMessage="The following equipment is provided for every guest:"
      />
    ),
    icon: 'mask',
    items: [
      {
        key: 'disinfectant_wipes',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.disinfectant_wipes"
            defaultMessage="Disinfecting wipes or spray and paper towels"
          />
        )
      },
      { key: 'gloves',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.gloves"
            defaultMessage="Disposable gloves"
          />
        )
      },
      { key: 'masks',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.masks"
            defaultMessage="Disposable masks / face coverings"
          />
        )
      },
      { key: 'hand_sanitizer',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.hand_sanitizer"
            defaultMessage="Hand Sanitizer"
          />
        )
      }
    ]
  },
  physical_distance: {
    heading: (
      <FormattedMessage
        id="shared_components.cleaning_types.physical_distance_header"
        defaultMessage="What have you done to help guests maintain physical distance in your space?"
      />
    ),
    listingHeader: (
      <FormattedMessage
        id="shared_components.cleaning_types.physical_distance_listing_header"
        defaultMessage="Physical distance"
      />
    ),
    listingSubheader: (
      <FormattedMessage
        id="shared_components.cleaning_types.physical_distance_listing_subheader"
        defaultMessage="The space has the following features:"
      />
    ),
    icon: 'physical-distance',
    items: [
      { key: 'capacity_guidelines',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.capacity_guidelines"
            defaultMessage="Capacity is limited based on governmental guidelines"
          />
        )
      },
      { key: 'outdoor_ventilation',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.outdoor_ventilation"
            defaultMessage="Space has access to outdoor air ventilation"
          />
        )
      },
      { key: 'certified_air_filters',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.certified_air_filters"
            defaultMessage="Space has HEPA-certified air filters"
          />
        )
      },
      { key: 'outdoor_space',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.outdoor_space"
            defaultMessage="Space has additional space outdoors"
          />
        )
      },
      { key: 'reconfigured_space',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.reconfigured_space"
            defaultMessage="Space has been reconfigured to allow for physical distance"
          />
        )
      }
    ]
  },
  signage: {
    heading: (
      <FormattedMessage
        id="shared_components.cleaning_types.signage_header"
        defaultMessage="What signage have you added to keep your guests informed?"
      />
    ),
    listingHeader: (
      <FormattedMessage
        id="shared_components.cleaning_types.signage_listing_header"
        defaultMessage="Signage"
      />
    ),
    listingSubheader: (
      <FormattedMessage
        id="shared_components.cleaning_types.signage_listing_subheader"
        defaultMessage="The space has informational signage including:"
      />
    ),
    icon: 'signage',
    items: [
      { key: 'checklist',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.checklist"
            defaultMessage="Detailed checklist of updated cleaning procedure. {link}"
            values={{
              link: (
                <a target="_blank" rel="noreferrer noopener" href="https://www.peerspace.com/resources/cleaning-checklist/">
                  <FormattedMessage
                    id="shared_components.cleaning_types.download_checklist"
                    defaultMessage="Download checklist"
                  />
                </a>
              )
            }}
          />
        )
      },
      { key: 'printouts',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.printouts"
            defaultMessage="COVID-19 guest guidelines print outs. {link}"
            values={{
              link: (
                <a target="_blank" rel="noreferrer noopener" href="https://www.peerspace.com/resources/guest-guidelines/">
                  <FormattedMessage
                    id="shared_components.cleaning_types.download_guidelines"
                    defaultMessage="Download guidelines"
                  />
                </a>
              )
            }}
          />
        )
      },
      { key: 'six_foot_markers',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.six_foot_markers"
            defaultMessage="Common areas have 6-foot (2-metre) markers on floors"
          />
        )
      },
      { key: 'arrows',
        label: (
          <FormattedMessage
            id="shared_components.cleaning_types.arrows"
            defaultMessage="Narrow passages have arrows for bi-directional traffic"
          />
        )
      }
    ]
  }
};

export default cleaningPolicy;
